// extracted by mini-css-extract-plugin
export default {"header":"Header_header__aT8IF","slide-left-enter":"Header_slide-left-enter__ZnEAl","header--main":"Header_header--main__A6p7+","header__content":"Header_header__content__p14Rr"};